// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"517":"1eb8ff89","721":"6e4ece5a","792":"18ca88f6"}[chunkId] + ".css";
};